import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import React from "react";

import GlobalOptions from "@/utils/global-options";

// Call the iOSVersion function to get the iOS version number
export default class IOSShaderUpdateMessage extends React.Component {
    constructor(props) {
        super(props);
        const affected = GlobalOptions.isBrokenShaderIOS;
        this.state = {
            showMessage: affected,
        };
    }

    clear() {
        this.setState({ showMessage: false });
        this.props.onClose(0); // 1000 * 60 * 60 * 24 * 4);
    }

    render() {
        return (
            <Dialog
                open={this.state.showMessage && !this.props.cleared}
                onClose={() => {
                    // this.setState({ showMessage: false });
                }}
            >
                <DialogTitle>iOS Update Recommended</DialogTitle>
                <DialogContent>
                    <Typography variant={"h4"}>Update your device for the best experience</Typography>
                    <br />
                    <DialogContentText>
                        Your current iOS version has a known issue that affects graphics performance. Please update to
                        the latest iOS version to restore full functionality.
                    </DialogContentText>
                    <br />
                    <DialogContentText>
                        <i>Go to Settings → General → Software Update to check for updates.</i>
                    </DialogContentText>
                    <br />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            this.clear();
                        }}
                        color={"primary"}
                    >
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
